import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Select } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { UIModuleStikeController } from "../../UI_ITO/indexUI";
import { SupportCallout } from "../../components/SupportCallout/SupportCallout";
import { KeyValueList } from "../../components/Ui/KeyValueList/KeyValueList";
import { IField } from "../../interfaces/IField";
import { RootState } from "../../store/Store";
import { useAppSelector } from "../../store/reduxHooks";
import {
  SELECT_PROFILE_DATA,
  SELECT_PROFILE_ROLE,
} from "../../store/selectors/profileSelectors";
import { User } from "../../store/slice/authSliceLogin/authSliceLogin";
import { USER } from "../../types/indexTypeEnum";
import { RenderFields } from "../../utils/HOC/RenderFields";
import { Guard } from "../../utils/guards/Guard";
import { formatPhoneNumber } from "../../utils/utilities/formatPhoneNumber";

import { getRoleName } from "../../utils/utilities/getRoleName";
import classes from "./PageProfile.module.css";

export function PageProfile() {
  const selectProfile = useAppSelector(SELECT_PROFILE_DATA);
  const userRole = useAppSelector(SELECT_PROFILE_ROLE);

  const personalData = [
    {
      key: "Фамилия",
      value: selectProfile?.surname,
      type: "text",
    },
    {
      key: "Имя",
      value: selectProfile?.name,
      type: "text",
    },
    {
      key: "Отчество",
      value: selectProfile?.patronymic,
      type: "text",
    },
    {
      key: "Телефон",
      value: selectProfile?.phone_number
        ? formatPhoneNumber(selectProfile?.phone_number)
        : "",
      type: "phone",
    },
  ];

  const personalFormData: IField[] = [
    {
      id: "1",
      label: "Фамилия",
      name: "surname",
      type: "text",
    },
    {
      id: "2",
      label: "Имя",
      name: "name",
      type: "text",
    },

    {
      id: "3",
      label: "Отчество",
      name: "patronymic",
      type: "text",
    },
    {
      id: "4",
      label: "Телефон",
      name: "phone",
      type: "phone",
    },
  ];

  const organizationData = [
    {
      key: "Наименование организации",
      value: selectProfile?.organization?.name,
    },
    {
      key: "Руководитель",
      value: "",
    },
    {
      key: "Номер договора",
      value: (
        <Guard.Role roles={[USER.AGENT_SIMPLE]}>
          {selectProfile?.user_contract &&
          selectProfile?.user_contract?.[0]?.is_sign
            ? selectProfile?.user_contract[0].number_contract
            : ""}
        </Guard.Role>
      ),
      isAgentFolder: true,
    },
    {
      key: "ОГРН",
      value: selectProfile?.organization && selectProfile?.organization?.ogrn,
    },
    {
      key: "ИНН",
      value: selectProfile?.organization && selectProfile?.organization?.inn,
    },
    {
      key: "Почтовый адрес",
      value: "",
    },
    {
      key: "Электронная почта",
      value: selectProfile?.organization?.email || selectProfile?.email,
    },
    {
      key: "КПП организции",
      value: "",
      isAgentFolder: true,
    },
    {
      key: "Юридический адрес",
      value: "",
      isAgentFolder: true,
    },
    {
      key: "БИК банка",
      value: "",
      isAgentFolder: true,
    },
    {
      key: "Полное наименование банка",
      value: "",
      isAgentFolder: true,
    },
    {
      key: "Расчетный счет агента",
      value: "",
      isAgentFolder: true,
    },
    {
      key: "Корреспондентский счет банка",
      value: "",
      isAgentFolder: true,
    },
  ];

  const filteredOrganisationData =
    userRole === USER.CLIENT_SIMPLE
      ? organizationData.filter((el) => !el.isAgentFolder)
      : organizationData;

  const selectProfileOld = useSelector(
    (state: RootState) => state.profileSlice,
  ) as User;
  const [form] = Form.useForm();
  const [isEditMode, setIsEditMode] = useState(false);

  function toggleEditMode() {
    setIsEditMode(!isEditMode);
  }

  return (
    selectProfileOld && (
      <div className={classes.pageProfile}>
        <div className={classes.pageProfile__content}>
          <div className={classes.pageProfile__header}>
            <h1 className={classes.pageProfile__heading}>Личный кабинет</h1>
            <span className={classes.pageProfile__role}>
              {getRoleName(selectProfile?.roles?.[0]?.name)}
            </span>
            <Button
              className={`${classes.pageProfile__toggleButton} ${isEditMode ? classes.pageProfile__toggleButton_isActive : ""}`}
              type="text"
              onClick={() => toggleEditMode()}
            >
              <EditOutlined className={classes.pageProfile__buttonIcon} />
            </Button>
          </div>
          <div className={classes.pageProfile__data}>
            {isEditMode ? (
              <Form
                className={classes.pageProfile__form}
                form={form}
                name="Profile_form"
              >
                <h2 className={classes.pageProfile__title}>
                  Личная информация
                </h2>
                <RenderFields columns={personalFormData} />
              </Form>
            ) : (
              <KeyValueList
                className={classes.pageProfile__list}
                data={personalData}
                title="Личная информация"
              />
            )}
            {userRole !== USER.MANAGER && (
              <KeyValueList
                className={classes.pageProfile__list}
                data={filteredOrganisationData}
                title={
                  userRole === USER.CLIENT_SIMPLE
                    ? "Информация об организации"
                    : "Данные организации"
                }
              />
            )}

            <Guard.Role roles={[USER.AGENT_SIMPLE]}>
              <div className={classes.pageProfile__section}>
                <h2 className={classes.pageProfile__title}>Документы</h2>
                <div className={classes.pageProfile__subsection}>
                  <h3 className={classes.pageProfile__subtitle}>Договоры</h3>
                  <Button className={classes.pageProfile__buttonUpload}>
                    <PlusOutlined className={classes.pageProfile__buttonIcon} />
                    Загрузить договор
                  </Button>
                  <Select
                    className={classes.pageProfile__select}
                    placeholder="Список загруженных договоров"
                  ></Select>
                </div>
                <div className={classes.pageProfile__subsection}>
                  <h3 className={classes.pageProfile__subtitle}>Акты</h3>
                  <Button className={classes.pageProfile__buttonUpload}>
                    <PlusOutlined className={classes.pageProfile__buttonIcon} />
                    Загрузить акт
                  </Button>
                  <Select
                    className={classes.pageProfile__select}
                    placeholder="Список загруженных актов"
                  ></Select>
                </div>
              </div>
            </Guard.Role>

            <SupportCallout className={classes.pageProfile__supportCallout} />

            <a
              href="/docs/formToRequest.docx"
              className={classes.formToRequestLink}
              download
            >
              Форма для запроса на доступ к своим персональным данным
            </a>
          </div>
        </div>

        <UIModuleStikeController>
          {isEditMode && (
            <>
              <Button
                className={`${classes.pageProfile__button} ${classes.pageProfile__button_type_cancel}`}
                onClick={() => toggleEditMode()}
              >
                Отменить
              </Button>
              <Button
                className={`${classes.pageProfile__button} ${classes.pageProfile__button_type_save}`}
                htmlType="submit"
                form="Profile_form"
              >
                Сохранить
              </Button>
            </>
          )}
        </UIModuleStikeController>
      </div>
    )
  );
}
